/****************************************************************
 * WARNING THIS FILE IS AUTOGENERATED AND SHOULD NOT BE MODIFIED *
 ****************************************************************/
import * as React from "react"
import Svg from "@oui/system/Svg"
type DefaultProps = typeof defaultProps
type SvgProps = React.ComponentPropsWithoutRef<typeof Svg>
type Props = DefaultProps &
  Omit<SvgProps, "fill" | "height" | "stroke" | "viewBox" | "width">
const defaultProps = {
  label: "Bold",
  size: 20
}

const SvgBold = ({ size, ...props }: Props) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="currentcolor"
    stroke="currentcolor"
    {...props}
  >
    <path d="M5 15.3c.66 0 .9-.3.9-.77V5.5c0-.58-.34-.8-.9-.8V4h3.95c3.65 0 4.75 1.37 4.75 2.9 0 .97-.56 2.27-2.84 2.69v.11c2.39.16 3.43 1.58 3.44 2.84C14.3 14.47 12.94 16 9 16H5v-.7zm4-6c2.19 0 2.8-.8 2.85-2.3 0-1.35-.55-2.2-2.85-2.2H7.67v4.5H9zm.185 5.92C11.97 15 12.39 14 12.4 12.58 12.4 11.15 11.39 10 9 10H7.67v5h1.51z" />
  </Svg>
)

SvgBold.defaultProps = defaultProps
export default SvgBold
